import { useParams } from 'react-router';
import { ContentSection } from '../../../components/Layout/ContentSection';
import { DepositClearingEventAccount } from './components/DepositClearingEventAccount';

export const DepositClearingPage = () => {
  const { eventAccountId, eventId } = useParams<{
    eventAccountId: string;
    eventId: string;
  }>();

  console.log({ eventAccountId, eventId });

  return (
    <ContentSection title="Deposit Clearing Page" collapsable={false}>
      <DepositClearingEventAccount
        eventAccountId={eventAccountId}
        eventId={eventId}
      />
    </ContentSection>
  );
};
